import { useTextes } from '@common/config';
import { OrganismeDetailsDto, TypeDeclaration } from '@common/services';
import { EtablissementInfoDto } from '@common/services/etablissement';
import { DsfrModal, FormMethodsRef, getModalById } from '@common/ui';
import { DateUtils } from '@common/utils';
import React, { useRef, useState } from 'react';
import { EditEtablissementInfoForm, EtablissementEditInfoModaldHandles } from '../form/EditEtablissementInfoForm';
import { TypeDeclarationChangeConfirmationModal } from './TypeDeclarationChangeConfirmationModal';

// bien laissé cette ligne en dehors du composant pour la modale de confirmation s'affiche
const typeDeclarationChangeValidationModal = getModalById('type-declaration-change-validation-modal');

export const EditEtablissementInfoModal = ({
                                             dsfrModal,
                                             isAddMode,
                                             organisme,
                                             etablissement,
                                             etablissementPrincipal,
                                           }: EtablissementEditInfoModalProps) => {

  const t = useTextes('Commun', 'Etablissements');

  const editEtablissementInfoFormRef = useRef<EtablissementEditInfoModaldHandles | null>(null);
  const [typeDeclarationTarget, setTypeDeclarationTarget] = useState<TypeDeclaration | null>(null);

  const buttonSubmitRef = useRef<HTMLButtonElement | null>(null);
  const formMethodsRef = useRef<FormMethodsRef | null>(null);

  const handleSubmit = () => {
    dsfrModal.close();
    formMethodsRef.current?.reset();
  };

  const typeDeclarationChangeConfirmationHandle = (typeDeclaration: TypeDeclaration) => {
    setTypeDeclarationTarget(typeDeclaration);
    typeDeclarationChangeValidationModal.open();
  };

  const onConfirmTypeDeclarationChangeModal = async () => {
    dsfrModal.close();
    typeDeclarationChangeValidationModal.close();
    await editEtablissementInfoFormRef.current?.onTypeDeclarationChangeConfirmation();
  };

  const onCancelTypeDeclarationChangeModal = async () => {
    // on rouvre la modale si le changement de type de declaration n'a pas été confirmé
    dsfrModal.open();
  };

  const title = (isAddMode) ? t['ETAB_OFA_PRIN_TEXTE1']
    : (etablissement.id) ?
      <span>Modification de l'établissement{(etablissement.principal) ? ' principal' : ''} {etablissement.denominationUsuelle}</span>
      : `CFA ${etablissement.denominationUsuelle}`;

  return (
    <>
      <dsfrModal.Component title={''}
                           size="large"
                           topAnchor={false}
                           buttons={[
                             {
                               children: 'ANNULER',
                               doClosesModal: true,
                               className: 'text-red-500!',
                               priority: 'tertiary',
                               onClick: () => formMethodsRef.current?.reset(),
                             },
                             {
                               children: (etablissement.id) ? 'VALIDER' : 'AJOUTER L\'ÉTABLISSEMENT',
                               doClosesModal: false,
                               className: 'uppercase',
                               priority: 'primary',
                               onClick: () => buttonSubmitRef.current?.click(),
                             },
                           ]}>

        <div className={'flex flex-col p-6'}>
          <div className={'flex flex-col gap-6'}>
            <h4 className={'m-0!'}>{title}</h4>
            {!isAddMode &&
              <span
                className={'text-sm text-[#484D7A] '}>Ajouté le {DateUtils.formatDdMmYyyy(etablissement.dateCreation)}</span>
            }
            <span className={'text-sm text-[#484D7A]'}>Les champs marqués d’un * sont obligatoires</span>

            <EditEtablissementInfoForm
              ref={editEtablissementInfoFormRef}
              etablissement={etablissement}
              etablissementPrincipal={etablissementPrincipal}
              isAddMode={isAddMode}
              organisme={organisme}
              buttonSubmitRef={buttonSubmitRef}
              formMethodsRef={formMethodsRef}
              submitHandler={handleSubmit}
              typeDeclarationChangeHandler={typeDeclarationChangeConfirmationHandle}
            />
          </div>
        </div>
      </dsfrModal.Component>

      <TypeDeclarationChangeConfirmationModal dsfrModal={typeDeclarationChangeValidationModal}
                                              typeDeclarationTarget={typeDeclarationTarget}
                                              onConfirm={onConfirmTypeDeclarationChangeModal}
                                              onCancel={onCancelTypeDeclarationChangeModal} />
    </>
  );
};

export interface EtablissementEditInfoModalProps {
  dsfrModal: DsfrModal;
  organisme: OrganismeDetailsDto;
  isAddMode: boolean;
  etablissement: EtablissementInfoDto;
  etablissementPrincipal?: EtablissementInfoDto;
}
